export { default } from './TableOfContents';
